import { ChefHat, Loader2, Plus } from 'lucide-react';

import ActionButton from '../../../../components/Buttons/ActionButton';
import SelectField from '../../../../components/Forms/Input/SelectField';
import { IBranchDropdown } from '../../../../types/branches/branchInterfaces';

interface RecipeHeaderProps {
  branches: IBranchDropdown[];
  branchId: number | '';
  loadingBranches: boolean;
  canPickBranch: boolean;
  createDisabled: boolean;
  onBranchChange: (branchId: number) => void;
  onCreate: () => void;
}

const RecipeHeader = ({
  branches,
  branchId,
  loadingBranches,
  canPickBranch,
  createDisabled,
  onBranchChange,
  onCreate,
}: RecipeHeaderProps) => (
  <div className="border-b border-stroke px-5 py-5 dark:border-strokedark sm:px-7">
    <div className="flex flex-col gap-5 xl:flex-row xl:items-end xl:justify-between">
      <div className="flex items-start gap-3">
        <span className="rounded-xl border border-primary/15 bg-primary/10 p-2.5 text-primary dark:border-primary/25 dark:bg-primary/15">
          <ChefHat className="h-5 w-5" />
        </span>

        <div>
          <h1 className="text-xl font-semibold text-black dark:text-white">
            Recetas
          </h1>

          <p className="mt-1 text-sm text-bodydark2">
            Configure rendimientos e ingredientes para cada producto del menú.
          </p>
        </div>
      </div>

      <div className="flex flex-col gap-3 sm:flex-row sm:items-end">
        {canPickBranch && (
          <div className="w-full sm:w-80">
            {loadingBranches ? (
              <div className="flex h-[74px] items-center justify-center rounded-xl border border-stroke bg-gray-2/50 dark:border-strokedark dark:bg-meta-4/30">
                <Loader2 className="h-5 w-5 animate-spin text-primary" />
              </div>
            ) : (
              <SelectField
                label="Sucursal"
                name="recipeBranch"
                value={branchId}
                iconKey="building"
                withMargin={false}
                options={branches.map((branch) => ({
                  value: branch.id,
                  label: branch.name,
                }))}
                onChange={(event) =>
                  onBranchChange(Number(event.target.value))
                }
              />
            )}
          </div>
        )}

        <ActionButton
          label="Nueva receta"
          icon={<Plus className="h-5 w-5" />}
          variant="primary"
          size="md"
          fullWidth={false}
          disabled={createDisabled}
          onClick={onCreate}
          className="h-[50px] whitespace-nowrap px-5"
        />
      </div>
    </div>
  </div>
);

export default RecipeHeader;